import React from 'react';

const CarCard = ({ car, isUsed }) => {
    // Базовый URL бэкенда для картинок
    const STORAGE_URL = 'http://localhost:8000/storage';

    return (
        <div style={cardStyles.card}>
            {/* Изображение:  URL сервера и путь из БД */}
            <div style={cardStyles.imageContainer}>
                <img 
                    src={car.image_path ? `${STORAGE_URL}/${car.image_path}` : '/assets/no-photo.jpg'} 
                    alt={car.name} 
                    style={cardStyles.image} 
                />
            </div>

            <div style={cardStyles.info}>
                <h3 style={cardStyles.name}>{car.name}</h3>
                
                <div style={cardStyles.details}>
                    <span>{car.year} г.</span>
                    <span>•</span>
                    <span>{car.body_type}</span>
                </div>

                <div style={cardStyles.priceRow}>
                    <span style={cardStyles.price}>
                        {new Intl.NumberFormat('en-US', { 
                            style: 'currency', 
                            currency: 'USD',
                            maximumFractionDigits: 0 
                        }).format(car.displayPrice)}
                    </span>
                    
                    {/* Ссылка на PDF, если он есть в БД */}
                    {car.pdf_file && (
                        <a 
                            href={`${STORAGE_URL}/${car.pdf_file}`} 
                            target="_blank" 
                            rel="noreferrer"
                            style={cardStyles.pdfLink}
                        >
                            PDF Спецификация
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

const cardStyles = {
    card: { border: '1px solid #eee', transition: '0.3s' },
    imageContainer: { width: '100%', height: '200px', overflow: 'hidden' },
    image: { width: '100%', height: '100%', objectFit: 'cover' },
    info: { padding: '20px' },
    name: { fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' },
    details: { color: '#666', fontSize: '14px', marginBottom: '15px', display: 'flex', gap: '5px' },
    priceRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    price: { fontSize: '20px', fontWeight: '800', color: '#0066cc' },
    pdfLink: { fontSize: '12px', color: '#666', textDecoration: 'underline' }
};

export default CarCard;